import React, {Dispatch, forwardRef, ForwardedRef} from 'react';
import { useMemo, useState } from 'react';
import { session } from '../../../types/types';
import DatePicker, { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import "react-datepicker/dist/react-datepicker.css";
import {
    Row,
    Col,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
} from 'reactstrap';

registerLocale('es', es);

interface DateSelectInputProps {
    value?: string;
    onClick?: () => void;
}

const SeleccionarFechaYHoraCalendario = ({ sesiones, status, horaSeleccionada, setHoraSeleccionada }: { sesiones: session[], status: string, horaSeleccionada:string, setHoraSeleccionada:Dispatch<string>  }) => {
    const [indiceSeleccionado, setIndiceSeleccionado] = useState<number | null>(null);
    const [fechaSeleccionada, setFechaSeleccionada] = useState<Date | null>(null);
    const [opcionSeleccionadaFecha, setOpcionSeleccionadaFecha] = useState('Selecciona Fecha');
    const [opcionSeleccionadaHora, setOpcionSeleccionadaHora] = useState('Selecciona Horario')
    const [dropdownOpenHora, setDropdownOpenHora] = useState(false);

    const parseSessionDate = (dateAsString: string) => {
        const [day, month, year] = dateAsString.split('-').map(Number);
        return new Date(year, month - 1, day);
    }

    const handleDropDownHora = () => {
        setDropdownOpenHora((prevState) => !prevState);
    }

    const fechasDisponibles = useMemo(() => {
        return sesiones.map((sesion) => parseSessionDate(sesion.date));
    }, [sesiones]);

    const handleFecha = (date: Date | null) => {
        if (!date) {
            return;
        }

        const index = sesiones.findIndex((sesion) => sesion.date === `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`);
        if (index === -1) {
            return;
        }

        setFechaSeleccionada(date);
        setIndiceSeleccionado(index);
        setOpcionSeleccionadaFecha(sesiones[index].title);
        setOpcionSeleccionadaHora('Seleccione Hora')
        setHoraSeleccionada('')
    }
    const handleHora = (title: string, code: string, status: string) => {
        if (status !== "0") {
            setOpcionSeleccionadaHora(title);
            handleDropDownHora()
            setHoraSeleccionada(code)
        }
    }

    const CustomDateSelect = forwardRef(({ value, onClick }: DateSelectInputProps, ref: ForwardedRef<HTMLDivElement>) => (
        <div
            ref={ref}
            className='select dropdown-toggle w-100'
            onClick={onClick}
            onKeyDown={(event) => {
                if ((event.key === 'Enter' || event.key === ' ') && onClick) {
                    onClick();
                }
            }}
            role='button'
            tabIndex={0}
            aria-haspopup='dialog'
        >
            <span>{opcionSeleccionadaFecha}</span>
        </div>
    ));

    return (
        <Row>
            <Col>
                <DatePicker
                    locale="es"
                    selected={fechaSeleccionada}
                    onChange={handleFecha}
                    includeDates={fechasDisponibles}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Selecciona Fecha"
                    customInput={<CustomDateSelect />}
                    popperPlacement="bottom"
                    calendarClassName="select-date-calendar"
                    wrapperClassName="select-date-wrapper"
                />

                <Dropdown isOpen={dropdownOpenHora} toggle={handleDropDownHora} direction='down'>
                    <DropdownToggle caret tag='div' className='select'>
                        <span>{opcionSeleccionadaHora}</span>
                    </DropdownToggle>
                    <DropdownMenu tag={'ul'} className='options'>
                        {indiceSeleccionado !== null && sesiones[indiceSeleccionado].hours.map((hora, index) => {
                            return <li className={hora.status === "0" ? 'disable-date' : ""} key={index} onClick={() => { handleHora(hora.hour, hora.code, hora.status);}}>{hora.hour} {hora.status === "0" ? '(AGOTADO)' : null}</li>;
                        })}
                    </DropdownMenu>
                </Dropdown>

            </Col>
        </Row>
    );
};
export default SeleccionarFechaYHoraCalendario;